/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_UpdatedInputs */

const en_region_updated = /** @type {(inputs: Region_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region updated`)
};

const es_region_updated = /** @type {(inputs: Region_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region actualizada`)
};

/**
* | output |
* | --- |
* | "Region updated" |
*
* @param {Region_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const region_updated = /** @type {((inputs?: Region_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_region_updated(inputs)
	return es_region_updated(inputs)
});